import React from "react";
import skills from "../assets/images/icons/Eligibility.svg";
import placement from "../assets/images/icons/placement.svg";
import info from "../assets/images/icons/AboutProg.svg";
import jigsaw from "../assets/images/icons/Selection.svg";
import age from "../assets/images/age.webp";
import education from "../assets/images/edu.webp";
import role from "../assets/images/role.webp";
import experience from "../assets/images/exp.webp";
import qualifingmarks from "../assets/images/quali.webp";
const KnowMoreElligibiltyComponent = () => {
  return (
    <>
      <section className="knowmore">
        <div className="container">
          <h2>Click below to know more</h2>

          <div className="row justify-content-center">
            <div className="col-lg-2 col-md-3 col-6">
              <a
                href="#scrollEligibility"
                className="knowMore_bx"
              >
                <div className="imgwrap">
                  <img
                    src={skills}
                    width="40px"
                    height="40px"
                    alt="The Eligibility"
                    className="img-fluid"
                  />
                </div>
                <p>Eligibility</p>
              </a>
            </div>
            <div className="col-lg-2 col-md-3 col-6">
              <a
                href="#scrolljobplace"
                className="knowMore_bx"
              >
                <div className="imgwrap">
                  <img
                    src={placement}
                    width="40px"
                    height="40px"
                    alt="The Placement and Salary"
                    className="img-fluid"
                  />
                </div>
                <p>Placement<br /> and salary</p>
              </a>
            </div>
            <div className="col-lg-2 col-md-3 col-6">
              <a
                href="#scrollAboutProg"
                className="knowMore_bx"
              >
                <div className="imgwrap">
                  <img
                    src={info}
                    width="40px"
                    height="40px"
                    alt="The About the Programme"
                    className="img-fluid"
                  />
                </div>
                <p>About the programme</p>
              </a>
            </div>
            <div className="col-lg-2 col-md-3 col-6">
              <a
                href="#scrollselprocess"
                className="knowMore_bx"
              >
                <div className="imgwrap">
                  <img
                    src={jigsaw}
                    width="40px"
                    height="40px"
                    alt="The Selection Process"
                    className="img-fluid"
                  />
                </div>
                <p>Selection process</p>
              </a>
            </div>
          </div>

        </div>
      </section>
      <section className="eligibility" id="scrollEligibility">
        <div className="container">
          <h2 className="title">Eligibility</h2>
          <div className="row my-md-5 my-4 justify-content-center gap30">
            <div className="col-md-6 col-lg-4">
              <div className="box">
                <img
                  src={age}
                  alt="Age"
                  className="eligiImg"
                  width="50px"
                  height="50px"
                />
                <h3 className="title">Age</h3>
                <p className="desc">25 years or below</p>

              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="box">
                  <img
                    src={qualifingmarks}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                  <h3 className="title">Qualifying Marks</h3>
                  <p className="desc">
                   Minimum 60% and above in 10th standard and Graduation
                  </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="box">
                  <img
                    src={education}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                  <h3 className="title">Education</h3>
                  <p className="desc">
                   Graduates, Engineers, Post-Graduates/MBAs
                  </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="box">
                  <img
                    src={role}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                  <h3 className="title">Role and Location<br /> Fungibility</h3>
                  <p className="desc">
                   Applicants should be willing to travel and work in Sales 
                  </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="box">
                  <img
                    src={experience}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                  <h3 className="title">Experience</h3>
                  <p className="desc">0 to 2 years</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KnowMoreElligibiltyComponent;
